import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import {
  getReadyForLogistics,
  getReadyForPo,
} from '../../utils/apiUtils/common';

const PAGE_SIZE = 20;

export const usePendingPO = (pageSize = 10) => {
  const [filters, setFilters] = useState({});
  const [page, setPage] = useState(0);

  const { data, isLoading, error } = useQuery({
    queryKey: [
      'pendingPO',
      page,
      filters.fromDate,
      filters.toDate,
      filters.searchValue,
    ],
    queryFn: () =>
      getReadyForPo({
        pageNumber: page,
        pageSize: pageSize,
        search: filters.searchValue || '',
        start: filters.fromDate || '',
        end: filters.toDate || '',
      }),
    keepPreviousData: true,
  });

  const fetchNextPage = () => {
    if (!data?.last) setPage((p) => p + 1);
  };

  const fetchPreviousPage = () => {
    if (page > 0) setPage((p) => p - 1);
  };

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
    setPage(0);
  };

  const handleClearFilters = () => {
    setFilters({});
    setPage(0);
  };

  return {
    filters,
    page,

    data: data?.content || [],
    isLoading,
    error,

    totalElements: data?.totalElements || 0,
    totalPages: data?.totalPages || 0,
    isFirst: page === 0,
    isLast: data?.last ?? true,

    pageSize: PAGE_SIZE,

    fetchNextPage,
    fetchPreviousPage,
    handleFilterChange,
    handleClearFilters,
  };
};

export const usePendingLogistics = (pageSize) => {
  const [filters, setFilters] = useState({});
  const [page, setPage] = useState(0);

  const { data, isLoading, error } = useQuery({
    queryKey: [
      'pendingLogistics',
      page,
      filters.fromDate,
      filters.toDate,
      filters.searchValue,
    ],
    queryFn: () =>
      getReadyForLogistics({
        pageNumber: page,
        pageSize: pageSize,
        search: filters.searchValue || '',
        start: filters.fromDate || '',
        end: filters.toDate || '',
      }),
    keepPreviousData: true,
  });

  return {
    filters,
    page,
    data: data?.content || [],
    isLoading,
    error,
    totalElements: data?.totalElements || 0,
    totalPages: data?.totalPages || 0,
    isFirst: page === 0,
    isLast: data?.last ?? true,
    pageSize: PAGE_SIZE,
    fetchNextPage: () => !data?.last && setPage((p) => p + 1),
    fetchPreviousPage: () => page > 0 && setPage((p) => p - 1),
    handleFilterChange: (f) => {
      setFilters(f);
      setPage(0);
    },
    handleClearFilters: () => {
      setFilters({});
      setPage(0);
    },
  };
};
